module.exports = __webpack_public_path__ + "img/thumbnail-zebra.f809e7fa.jpg";